import React from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import "../../../assets/css/region-access.css";

const TokenFinished = ({ isOpen, toggle }) => {
  return (
    <>
      {isOpen && <div className="modal-backdrop-blur" />}
      <Modal show={isOpen} centered  className="AiPopupOuter">
        <span
          onClick={() => toggle(false)}
          style={{
            color: "#fff",
            opacity: "unset",
            position: "absolute",
            top: "3%",
            right: "3%",
            cursor: "pointer",
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </span>
        <div className="modal-header">
          <img src="/images/ai-logo.jpg" />
        </div>
        <Modal.Body>
          <h2>Dear User</h2>
          <p>
            Your access to complimentary tokens for attempting questions has been
            exhausted. Upgrade to enjoy Unlimited Practice Questions with AI
            Scoring.
          </p>
          <div className="AiUpgradeBtn">
            <Link to={"/admin/plans"} className="modalCloseBtn btn">
              Upgrade
            </Link>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TokenFinished;
